import { useQuery } from 'hooks/useCustomQuery';
import { useEffect } from 'react';
import { getRegistrars } from 'API/TRSRegistrar/getRegistrars';

const useGetRegistrars = (setTableData, gridRef, colDefs, currentCompany) => {
    const query = useQuery({
        queryKey: ['Registrars'],
        queryFn: async () => {
            if (!currentCompany) {
                throw new Error('No company selected');
            }
            const response = await getRegistrars(currentCompany);
            return response.data;
        },
        throwOnError: true,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
        enabled: !!currentCompany,
    });

    // Handle data updates using useEffect instead of deprecated onSuccess
    useEffect(() => {
        if (query.data) {
            setTableData({
                columns: colDefs,
                data: query.data,
            });
        }
    }, [query.data, setTableData, colDefs, gridRef]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetRegistrars;
